import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';

const TechnicianProfile = () => {
    const { id } = useParams();
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProfile = async () => {
            setLoading(true);
            try {
                const res = await axios.get(`https://local-technician-finder-backend.onrender.com/api/technicians/${id}`);
                setProfile(res.data);
            } catch (err) {
                console.error(err);
                setError('Failed to fetch technician profile.');
            } finally {
                setLoading(false);
            }
        };
        fetchProfile();
    }, [id]);

    if (loading) return <LoadingSpinner />;
    if (error) return <div>{error}</div>;
    if (!profile) return <div>No profile found.</div>;

    return (
        <div className="container mt-4">
            <div className="card shadow-sm">
                <div className="card-body">
                    <h1 className="card-title text-center mb-4">{profile.firstName} {profile.lastName}</h1>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <p className="mb-1"><strong>Email:</strong> {profile.userId.email}</p>
                            <p className="mb-1"><strong>Phone:</strong> {profile.phone}</p>
                            <p className="mb-1"><strong>Address:</strong> {profile.address}</p>
                            <p className="mb-1"><strong>Pincode:</strong> {profile.pincode}</p>
                        </div>
                        <div className="col-md-6">
                            <p className="mb-1"><strong>Hourly Rate:</strong> ${profile.hourlyRate}</p>
                            <p className="mb-1"><strong>Average Rating:</strong> {profile.averageRating.toFixed(1)} ({profile.totalReviews} reviews)</p>
                            <p className="mb-1"><strong>Services Offered:</strong> {
                                profile.servicesOffered && profile.servicesOffered.length > 0 
                                    ? profile.servicesOffered.map(s => s.name).join(', ') 
                                    : 'No services specified'
                            }</p>
                        </div>
                    </div>
                    <div className="mt-3">
                        <h5>Bio:</h5>
                        <p className="card-text">{profile.bio}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TechnicianProfile;